import React from 'react';
import { convertColorToThemeHexCode } from 'Styles/colors.util';
import { detectTouch } from '../../../../../../util/util';
import * as Styled from './SelectThumbnail.styled';
/**
 * Component that renders thumbnails
 * To be used with an image carousel (ImageCarouselMedium)
 */
var SelectThumbnail = function (_a) {
    var images = _a.images, onThumbnailClick = _a.onThumbnailClick, slideInView = _a.slideInView, clickedSlide = _a.clickedSlide, isUserScrolling = _a.isUserScrolling, isUserTabbing = _a.isUserTabbing;
    /**
     * hover styling was causing unintended effects on touch devices
     * this will check if the current device is a touch device
     * if not, we add hover state
     */
    var hasTouch = detectTouch();
    var thumbnailImages = images.map(function (image, index) { return (React.createElement(Styled.Image, { key: image.id || index, "data-id": image.id || index, background: convertColorToThemeHexCode('grey20'), resolution: { small: 180 }, crop: {
            height: 3040,
            width: 3040
        }, src: image.src, alt: image.alt, tabIndex: 0, onClick: function () {
            onThumbnailClick(index);
        }, onFocus: function () {
            onThumbnailClick(index);
        }, "$clickedState": !isUserTabbing && clickedSlide === index, "$tabbedState": isUserTabbing && slideInView === index, "$scrolledState": isUserScrolling && slideInView === index, "$hasTouch": hasTouch })); });
    return (React.createElement(Styled.SelectThumbnail, null, thumbnailImages.map(function (image) { return image; })));
};
export default SelectThumbnail;
